/* Every time the window is scrolled ... */

jQuery(window).scroll(function() {
    if (jQuery(window).width() >= 781) {  // Check if window width is 1000px or greater
        jQuery('.mattcross-fade-in').each(function(i) {
            var bottom_of_object = jQuery(this).offset().top + jQuery(this).outerHeight();
            var bottom_of_window = jQuery(window).scrollTop() + jQuery(window).height();

            if (bottom_of_window > bottom_of_object) {
                jQuery(this).animate({'opacity':'1'}, 250);
            }
        });
    } else {
        jQuery("div").removeClass("mattcross-fade-in");

    }
});

// Use on the Book page
jQuery(".mattcross-remove-fade").click(function(){
    jQuery("div").removeClass("mattcross-book-reviews");
    jQuery("div").removeClass("mattcross-read-more-button");
    jQuery(this).hide();
});